import React from "react";
import PropTypes from "prop-types";
import { Input } from "reactstrap";
import debouce from "lodash/debounce";

const DebouncedInput = ({ onChange, timeout, ...props }) => {
  const debouncedOnChange = debouce(onChange, timeout);

  return <Input {...props} onChange={e => debouncedOnChange(e.target.value)} />;
};

DebouncedInput.propTypes = {
  onChange: PropTypes.func,
  timeout: PropTypes.number
};

DebouncedInput.defaultProps = {
  onChange: () => {},
  timeout: 300
};

export default DebouncedInput;
